import IconClose from "../icons/IconClose";
import Spacer from "./Spacer";

export default function Popup({ title, content, isActive = false, onClosed }) {
  return (
    <div className={`popup ${isActive ? "active" : ""}`}>
      <div className="popup-overlay" onClick={onClosed}></div>
      {content && (
        <div className="popup-content">
          <h2>
            {title}
            <Spacer height="20px" />
            <div className="popup-close" onClick={onClosed}>
              <IconClose color="white" />
            </div>
          </h2>
          {content}
        </div>
      )}
    </div>
  );
}
